import * as React from 'react';
import { SkeletonVariantsEnum, SkeletonAnimationsEnum, SkeletonRoot } from './SkeletonRoot';
export var Skeleton = function (_a) {
    var ariaLabel = _a.ariaLabel, width = _a.width, height = _a.height, _b = _a.variant, variant = _b === void 0 ? SkeletonVariantsEnum.TEXT : _b, _c = _a.animation, animation = _c === void 0 ? SkeletonAnimationsEnum.PULSE : _c;
    return (React.createElement(SkeletonRoot, { "aria-label": ariaLabel, variant: variant, width: width, height: height, animation: animation }));
};
//# sourceMappingURL=Skeleton.js.map